import { useEffect, useState } from 'react';

export const useElementWidth = (selector: string) => {
	const [width, setWidth] = useState<number>();

	useEffect(() => {
		const el = document.querySelector(selector) as HTMLElement | null;
		if (!el) return;

		const measure = () => setWidth(el.offsetWidth);

		measure();

		const observer = new ResizeObserver(measure);
		observer.observe(el);
		window.addEventListener('resize', measure);

		return () => {
			observer.disconnect();
			window.removeEventListener('resize', measure);
		};
	}, [selector]);

	return width;
};
